<template>
    <div class="shift-end-page page-content">
        <h2>Entrega de Turno</h2>
        <app-shift-form :is-start="false" />
    </div>
</template>
<script>
    import ShiftForm from '../../ShiftForm/ShiftForm.vue';
    export default {
        components: {
            appShiftForm: ShiftForm
        }
    }
</script>